import styled from 'styled-components'
import vector from '../../../../assets/equipment/vector.svg'



export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
`

export const ModalContainer = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: hidden;
  width: 60vw;
  color: #303030;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);

  @media (max-width: 1280px) {
    width: 70vw;
  }

  @media (max-height: 768px) {
    max-height: 95vh;
    top: 50%;
  }

  @media (max-width: 768px) {
    width: 90vw;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 2.4vw);
  padding: 3.5vh 0;
  margin-left: 1.2vw;
  margin-right: 1.2vw;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-height: 768px) {
    padding: 2vh 0;
  }
`

export const ModalTitle = styled.h2`
  font-size: 1.4vw;
  font-weight: 700;
  margin: 0;
`

export const CloseButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;
  background-color: #eaeaea;

  img {
    width: 12px;
    height: 12px;
  }
`

export const ModalContent = styled.div`
  padding: 1.2vw;
  display: flex;
  flex-direction: column;
  gap: 1.2vh;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  @media (max-height: 768px) {
    padding: 1vh 1.2vw;
    gap: 1vh;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 2.5vh 1.2vw;
  border-top: 1px solid #e0e0e0;
  gap: 15px;
  flex-shrink: 0;

  @media (max-height: 768px) {
    padding: 1.5vh 1.2vw;
  }
`



export const FormGroup = styled.div`
  margin-bottom: 12px;
`

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
`

export const Input = styled.input`
  width: 100%;
  padding: 8px 15px;
  font-size: 14px;
  color: #696969;
  background-color: #ebebeb;
  border: 1px solid transparent;
  border-radius: 100px;
  height: 40px;
  box-sizing: border-box;

  &::placeholder {
    color: #c4c4c4;
  }

  &:focus {
    outline: none;
  }
`

export const Select = styled.select`
  width: 100%;
  padding: 8px 35px 8px 15px;
  font-size: 14px;
  color: #696969;
  background-color: #ebebeb;
  border: 1px solid transparent;
  border-radius: 100px;
  height: 40px;
  box-sizing: border-box;
  appearance: none;
  background-image: url(${vector});
  background-size: 18px 9px;
  background-repeat: no-repeat;
  background-position: right 15px center;
  cursor: pointer;
  min-width: 200px;

  &:focus {
    outline: none;
  }

  option {
    color: #696969;
  }

  
  &:invalid {
    color: #c4c4c4;
  }
`


export const MaterialSelect = styled.select`
  width: 100%;
  padding: 8px 15px;
  font-size: 14px;
  color: #696969;
  background-color: #ebebeb;
  border: 1px solid transparent;
  border-radius: 100px;
  height: 40px;
  box-sizing: border-box;
  appearance: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  option {
    color: #696969;
  }

  
  &:invalid {
    color: #c4c4c4;
  }
`


export const ResourceSelect = styled.select`
  width: 100%;
  padding: 8px 15px;
  font-size: 14px;
  color: #696969;
  background-color: #ebebeb;
  border: 1px solid transparent;
  border-radius: 100px;
  height: 40px;
  box-sizing: border-box;
  appearance: none;
  cursor: default;

  &:focus {
    outline: none;
  }

  option {
    color: #696969;
  }

  &:disabled {
    opacity: 0.7;
    cursor: default;
  }
`

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const SearchIcon = styled.span`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  img {
    width: 16px;
    height: 16px;
    opacity: 0.6;
  }
`



export const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
`

export const DropdownItem = styled.div<{ $isHighlighted?: boolean }>`
  padding: 10px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  background: ${(props) => (props.$isHighlighted ? '#f9fafb' : 'white')};
  transition: background 0.15s ease;

  &:hover {
    background: #f9fafb;
  }

  &:last-child {
    border-bottom: none;
  }
`

export const DropdownEmptyState = styled.div`
  padding: 10px 16px;
  color: #6b7280;
  text-align: center;
`



export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`

export const Tag = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 100px;
  font-size: 14px;
  color: #696969;
`

export const RemoveTagButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 10px;
    height: 10px;
  }
`



export const GraduationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const GraduationItem = styled.div`
  padding: 16px;
  background-color: #f9f9f9;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
`

export const GraduationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
`

export const RemoveGraduationButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;

  img {
    width: 20px;
    height: 20px;
  }
`

export const GradesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
`

export const GradeButton = styled.button<{ $isSelected: boolean }>`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.$isSelected ? '#0090d3' : '#6b7280')};
  background-color: ${(props) => (props.$isSelected ? '#e0f7ff' : 'white')};
  border: 1.5px solid ${(props) => (props.$isSelected ? '#0090d3' : '#e5e7eb')};
  border-radius: 100px;
  cursor: pointer;
  min-width: 55px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const AddGraduationButton = styled.button`
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #0090d3;
  background-color: transparent;
  border: 2px dashed #0090d3;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 8px;

  svg {
    width: 18px;
    height: 18px;
  }
`



export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const SaveButton = styled.button`
  background-color: #0090d3;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`